import React, { useState } from "react"
import LogoAgendaBlue from "../images/logo-agenda-blue.svg"
import { Link } from "gatsby"

export const Header = () => {
  return (
    <div
      data-collapse="medium"
      data-animation="default"
      data-duration="400"
      role="banner"
      className="navbar w-nav"
    >
      <div className="container-1200 top-menu w-container">
        <div className="div-50 logo-menu">
          <Link to="/listado" className="brand-logo w-nav-brand new-button">
            <img
              src={LogoAgendaBlue}
              loading="lazy"
              alt="Agenda PUCP web link"
            />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Header
